exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:block;padding:2rem}:host .alert-danger a{color:#f8f9fa;text-decoration:underline}:host .alert-danger a:hover{color:#bdc6d0}:host label{pointer-events:all!important}:host .form-check>input,:host .form-check>label{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/user-club/user-club-modal/user-club-modal.component.scss
// module id = 751
// module chunks = 0